import React from 'react';
import PropTypes from 'prop-types';
import { DialogContent } from '@material-ui/core';
import { Dialog, Button, Typography } from '@knockrentals/knock-shared-web-v2';
import TransferTargetSelect from './TransferTargetSelect';
import useTransferTarget from './useTransferTarget';

const transferDescription =
  'Only non-migrated managers will be available as the new property owner';

const PropertyTransferTarget = ({
  companies,
  fetchCompanies,
  handleTransferProperty,
  onClose,
  propertyOwner,
  setErrorMessage,
  setIsLoading,
}) => {
  const shouldFetchCompanies = !companies;

  const {
    company,
    handleCompanyOnChange,
    handleLeasingTeamOnChange,
    handleOnFocus,
    handleTransferOnClick,
    handleManagerOnChange,
    isTransferDisabled,
    leasingTeam,
    leasingTeams,
    manager,
    managers,
    validationErrorMessages,
  } = useTransferTarget({
    fetchCompanies,
    handleTransferProperty,
    setErrorMessage,
    setIsLoading,
    shouldFetchCompanies,
  });

  return (
    <React.Fragment>
      <Typography
        align="center"
        color="textSecondary"
        component="h6"
        gutterBottom
        paragraph
        variant="body2"
      >
        {transferDescription}
      </Typography>

      <DialogContent>
        <TransferTargetSelect
          companies={companies || []}
          company={company}
          handleCompanyOnChange={handleCompanyOnChange}
          handleLeasingTeamOnChange={handleLeasingTeamOnChange}
          handleOnFocus={handleOnFocus}
          handleManagerOnChange={handleManagerOnChange}
          leasingTeam={leasingTeam}
          leasingTeams={leasingTeams}
          manager={manager}
          managers={managers}
          propertyOwner={propertyOwner}
          validationErrorMessages={validationErrorMessages}
        />
      </DialogContent>

      <Dialog.Actions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>

        <Button disabled={isTransferDisabled} onClick={handleTransferOnClick}>
          Transfer
        </Button>
      </Dialog.Actions>
    </React.Fragment>
  );
};

PropertyTransferTarget.propTypes = {
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      companyId: PropTypes.number,
      companyName: PropTypes.string,
    }),
  ),
  fetchCompanies: PropTypes.func,
  handleTransferProperty: PropTypes.func,
  onClose: PropTypes.func,
  propertyOwner: PropTypes.number,
  setErrorMessage: PropTypes.func,
  setIsLoading: PropTypes.func,
};

export default PropertyTransferTarget;
